
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Risultati from "../pages/risultati/page";
import Corsi from "../pages/corsi/page";
import Servizi from "../pages/servizi/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/risultati",
    element: <Risultati />,
  },
  {
    path: "/servizi",
    element: <Servizi />,
  },
  {
    path: "/corsi",
    element: <Corsi />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
